var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEyeWhisper(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "9px",
    viewBox: "0 0 14 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icEyeWhisper") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.6867285,3.29441193 C13.8887572,3.4979425 13.9999998,3.76983847 13.9999998,4.05982604 C14.0001689,4.34998757 13.8889263,4.62188354 13.6868975,4.82558807 C12.7038037,5.81610352 10.0843617,8.12 7,8.12 C3.91546923,8.12 1.29619627,5.81627748 0.313271528,4.82576203 C0.111073731,4.6220575 -0.000168869287,4.35016153 1.92416072e-07,4.06 C1.92416072e-07,3.76983847 0.111242793,3.49811646 0.313271528,3.29458589 C1.29619627,2.30407044 3.91563829,8.8817842e-15 7,8.8817842e-15 C10.0841926,8.8817842e-15 12.7036347,2.30389648 13.6867285,3.29441193 Z M7,1.62650499 C5.69585802,1.62650499 4.63499584,2.71808989 4.63499584,4.06 C4.63499584,5.40191011 5.69585802,6.49349501 7,6.49349501 C8.30414198,6.49349501 9.36500416,5.40191011 9.36500416,4.06 C9.36500416,2.71808989 8.30397291,1.62650499 7,1.62650499 Z M7,5.7338215 C6.10312767,5.7338215 5.37328829,4.98284588 5.37328829,4.06 C5.37328829,3.13715412 6.1029586,2.3861785 7,2.3861785 C7.8970414,2.3861785 8.62671171,3.13698016 8.62671171,4.06 C8.62671171,4.98301984 7.89687233,5.7338215 7,5.7338215 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icEyeWhisper",
    fill: "#A5A5A5",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEyeWhisper);
export default __webpack_public_path__ + "static/media/icEyeWhisper.d260b97d592f765bcb5784f421d71ca2.svg";
export { ForwardRef as ReactComponent };